import React from 'react';
class BannerTab extends React.Component {
  render() {
    if (this.props.isSelected) {
      return (
        <div className="mainContainer" style={{marginTop:115}}>
          { this.props.children }
        </div>
      );
    }
    return null;
  }
}
export default BannerTab;